import { Charts } from './Charts';
import RankingsChartsDataProvider from './contexts/RankingsChartsDataContext';

const RankingsWrapper = () => {
    return (
        <RankingsChartsDataProvider>
            <Charts />
        </RankingsChartsDataProvider>
    );
};

export default RankingsWrapper;
